export default __webpack_public_path__ + "static/media/first-rating-msg-mobile.80750da6.svg";